<template>
  <section class="why-sogdo position-relative see__pad">
    <!-- Multiple Pattern Layers -->
    <div class="pattern-layer">
      <div class="pattern-1 position-absolute" style="background-image: url('/shapes/shape-06.png')"></div>
    </div>
    <div class="pattern-layer">
      <div class="pattern-2 position-absolute" style="background-image: url('/shapes/shape-08.png')"></div>
    </div>
    
    <div class="container d-block">
      <div class="row">
        <div class="col-lg-12">
          <div class="why-sogdo-header text-center">
            <div class="why-sogdo-section-label">
              <h4>{{ content.sectionLabel }}</h4>
            </div>
            <div class="why-sogdo-main-title">
              <h2>{{ content.mainTitle }} <span>{{ content.mainTitleHighlight }}</span></h2>
            </div>
            <div class="why-sogdo-description">
              <p>{{ content.description }}</p>
            </div>
          </div>
        </div>
      </div>
      
      <div class="why-sogdo-blocks-container">
        <div 
          v-for="(block, index) in content.blocks" 
          :key="index"
          class="why-sogdo-block position-relative"
          :class="`${block.blockClass}`"
        >
          <div class="why-sogdo-block-bg">
            <div class="block-shape-1" :style="`background-image: url('${block.shape1}')`"></div>
            <div class="block-shape-2" :style="`background-image: url('${block.shape2}')`"></div>
          </div>
          <div class="why-sogdo-block-content">
            <div class="why-sogdo-block-icon">
              <i :class="block.icon"></i>
            </div>
            <h3>{{ block.title }}</h3>
            <p>{{ block.description }}</p>
            <ul>
              <li v-for="(feature, featureIndex) in block.features" :key="featureIndex">{{ feature }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "HomeItsWhySogdoComp",
  props: {
    content: {
      type: Object,
      required: true,
      default: () => ({
        sectionLabel: "Why Sogdo",
        mainTitle: "Why Choose",
        mainTitleHighlight: "Sogdo",
        description: "We combine cutting-edge technology with proven expertise to deliver solutions that scale with your business and drive innovation forward.",
        blocks: [
          {
            blockClass: "scalability-block",
            icon: "icon-06",
            title: "Champa Methodology",
            description: "Reduce service & development cost by 40% with our proven methodology that optimizes processes and maximizes efficiency.",
            features: [
              "40% Cost Reduction",
              "Optimized Processes",
              "Proven Methodology",
              "Maximum Efficiency"
            ],
            shape1: "/shapes/shape-01.png",
            shape2: "/shapes/shape-11.png"
          },
          {
            blockClass: "expertise-block",
            icon: "icon-07",
            title: "Full-cycle Product Teams",
            description: "Complete end-to-end development teams with expertise in every aspect of software product development and delivery.",
            features: [
              "End-to-end Development",
              "Cross-functional Teams",
              "Complete Product Lifecycle",
              "Integrated Solutions"
            ],
            shape1: "/shapes/shape-02.png",
            shape2: "/shapes/shape-12.png"
          },
          {
            blockClass: "innovation-block",
            icon: "icon-08",
            title: "Modern Tech Stack & Architecture",
            description: "Cutting-edge technology stack and modern architecture patterns that ensure scalability, performance, and future-proof solutions.",
            features: [
              "Latest Technologies",
              "Modern Architecture",
              "Scalable Solutions",
              "Future-proof Design"
            ],
            shape1: "/shapes/shape-04.png",
            shape2: "/shapes/shape-10.png"
          },
          {
            blockClass: "support-block",
            icon: "icon-09",
            title: "24x7 Support & Maintenance",
            description: "Round-the-clock support and maintenance services to ensure your systems run smoothly and efficiently at all times.",
            features: [
              "24/7 Monitoring",
              "Rapid Response",
              "Proactive Maintenance",
              "Continuous Support"
            ],
            shape1: "/shapes/shape-03.png",
            shape2: "/shapes/shape-09.png"
          },
          {
            blockClass: "speed-block",
            icon: "icon-10",
            title: "Fast Time to Market",
            description: "Accelerated development processes and agile methodologies that help you launch your products faster than ever before.",
            features: [
              "Agile Development",
              "Rapid Prototyping",
              "Quick Iterations",
              "Faster Launch"
            ],
            shape1: "/shapes/shape-05.png",
            shape2: "/shapes/shape-07.png"
          }
        ]
      })
    }
  }
}
</script>

<style scoped>
/* Why Sogdo Section Styles */
.why-sogdo {
  padding: 100px 0;
  background: #00061A;
  position: relative;
  overflow: hidden;
}

.why-sogdo .pattern-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.why-sogdo .pattern-1 {
  top: 15%;
  right: 8%;
  width: 120px;
  height: 120px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.1;
}

.why-sogdo .pattern-2 {
  bottom: 20%;
  left: 5%;
  width: 100px;
  height: 100px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.08;
}

.why-sogdo-header {
  position: relative;
  z-index: 2;
  margin-bottom: 60px;
}

.why-sogdo-section-label h4 {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 13.2px;
  color: #F6EC4F;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
  text-transform: uppercase;
}

.why-sogdo-main-title h2 {
  font-size: 48px;
  font-weight: 700;
  line-height: 58px;
  color: #fff;
  margin-bottom: 30px;
  font-family: 'Archivo', sans-serif;
}

.why-sogdo-main-title h2 span {
  color: #F6EC4F;
}

.why-sogdo-description p {
  font-size: 18px;
  line-height: 28px;
  color: #fff;
  margin-bottom: 0;
  font-family: 'Open Sans', sans-serif;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

/* Why Sogdo Blocks - Similar to Offerings */
.why-sogdo-blocks-container {
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 40px;
  margin-top: 60px;
  margin-bottom: 40px;
}

.why-sogdo-block {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(246, 236, 79, 0.1);
  border-radius: 15px;
  padding: 30px 25px;
  text-align: left;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  height: auto;
  min-height: 280px;
}

.why-sogdo-block-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  pointer-events: none;
}

.why-sogdo-block .block-shape-1 {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 60px;
  height: 60px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.3;
}

.why-sogdo-block .block-shape-2 {
  position: absolute;
  bottom: 10px;
  left: 10px;
  width: 40px;
  height: 40px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.2;
}

.why-sogdo-block:hover {
  transform: translateY(-5px);
  border-color: #F6EC4F;
  box-shadow: 0 15px 30px rgba(246, 236, 79, 0.15);
}

.why-sogdo-block-content {
  position: relative;
  z-index: 2;
}

.why-sogdo-block-icon {
  margin-bottom: 20px;
  text-align: center;
}

.why-sogdo-block-icon i {
  font-size: 40px;
  color: #F6EC4F;
  display: inline-block;
  width: 60px;
  height: 60px;
  line-height: 60px;
  background: rgba(246, 236, 79, 0.1);
  border-radius: 50%;
  transition: all 0.3s ease;
}

.why-sogdo-block:hover .why-sogdo-block-icon i {
  background: #F6EC4F;
  color: #00061A;
  transform: scale(1.1);
}

.why-sogdo-block-content h3 {
  font-size: 24px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 15px;
  font-family: 'Archivo', sans-serif;
}

.why-sogdo-block-content p {
  font-size: 16px;
  line-height: 26px;
  color: #fff;
  margin-bottom: 25px;
  font-family: 'Open Sans', sans-serif;
}

.why-sogdo-block-content ul {
  list-style: none;
  padding: 0;
  margin: 0 0 20px 0;
}

.why-sogdo-block-content li {
  font-size: 14px;
  color: #F6EC4F;
  margin-bottom: 8px;
  font-family: 'Open Sans', sans-serif;
  position: relative;
  padding-left: 20px;
}

.why-sogdo-block-content li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: #F6EC4F;
  font-weight: bold;
  font-size: 12px;
}

/* Block-specific styles */
.scalability-block {
  border-color: rgba(246, 236, 79, 0.2);
}

.expertise-block {
  border-color: rgba(150, 6, 147, 0.2);
}

.innovation-block {
  border-color: rgba(0, 123, 255, 0.2);
}

.support-block {
  border-color: rgba(192, 10, 135, 0.2);
}

.speed-block {
  border-color: rgba(246, 236, 79, 0.2);
}

/* Responsive Design */
@media only screen and (max-width: 991px) {
  .why-sogdo {
    padding: 80px 0;
  }
  
  .why-sogdo-header {
    margin-bottom: 50px;
  }
  
  .why-sogdo-blocks-container {
    margin-top: 50px;
  }
}

@media only screen and (max-width: 767px) {
  .why-sogdo {
    padding: 60px 0;
  }
  
  .why-sogdo-header {
    margin-bottom: 40px;
  }
  
  .why-sogdo-blocks-container {
    margin-top: 40px;
  }
  
  .why-sogdo-main-title h2 {
    font-size: 36px;
    line-height: 46px;
  }
  
  .why-sogdo-description p {
    font-size: 16px;
  }
  
  .why-sogdo-blocks-container {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .why-sogdo-block {
    padding: 25px 20px;
    min-height: 250px;
  }
  
  .why-sogdo-block-content h3 {
    font-size: 20px;
  }
  
  .why-sogdo-block-content p {
    font-size: 14px;
    line-height: 22px;
  }
  
  .why-sogdo .pattern-1,
  .why-sogdo .pattern-2 {
    opacity: 0.05;
  }
}

@media only screen and (max-width: 399px) {
  .why-sogdo {
    padding: 40px 0;
  }
  
  .why-sogdo-header {
    margin-bottom: 30px;
  }
  
  .why-sogdo-blocks-container {
    margin-top: 30px;
  }
  
  .why-sogdo-main-title h2 {
    font-size: 28px;
    line-height: 38px;
  }
  
  .why-sogdo-section-label h4 {
    font-size: 16px;
    letter-spacing: 8px;
  }
  
  .why-sogdo-block {
    padding: 20px 15px;
    min-height: 220px;
  }
  
  .why-sogdo-block-content h3 {
    font-size: 18px;
  }
  
  .why-sogdo-block-content p {
    font-size: 13px;
    line-height: 20px;
  }
  
  .why-sogdo-block-icon i {
    width: 50px;
    height: 50px;
    line-height: 50px;
    font-size: 30px;
  }
  
  .why-sogdo-block .block-shape-1 {
    width: 40px;
    height: 40px;
  }
  
  .why-sogdo-block .block-shape-2 {
    width: 30px;
    height: 30px;
  }
}
</style>
